import { Box, Button } from "@compass/core";
import {
    Dialog,
    DialogTitle,
    DialogContent,
} from "@mui/material";
import { DashboardCardContext } from "./DashboardCard";
import { DASHBOARD_CARD_REGISTRY } from "../DashboardCardRegistry";
import { CardId, DashboardCardConfig } from "../types";

// Dialog sizing constants
const DIALOG_HORIZONTAL_MARGIN = 64; // Account for sidebar/page padding

interface ExpandedCardDialogProps {
    cardId: CardId | null;
    cardConfigs: DashboardCardConfig[];
    onClose: () => void;
}

export const ExpandedCardDialog = ({
    cardId,
    cardConfigs,
    onClose,
}: ExpandedCardDialogProps) => {
    const isOpen = cardId !== null;

    const title = cardId
        ? cardConfigs.find((c) => c.id === cardId)?.name ?? ""
        : "";

    // Get the card component if cardId is valid
    const CardComponent = cardId ? DASHBOARD_CARD_REGISTRY[cardId] : null;

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            maxWidth={false}
            fullWidth
            PaperProps={{
                sx: {
                    width: `calc(85vw - ${DIALOG_HORIZONTAL_MARGIN}px)`,
                    maxWidth: "none",
                    height: "65vh",
                    maxHeight: "65vh",
                    borderRadius: 3,
                },
            }}
        >
            <DialogTitle
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    bgcolor: "primary.main",
                    color: "white",
                    py: 1.5,
                }}
            >
                {title}
                <Button
                    onClick={onClose}
                    variant="outlined"
                    aria-label="Close expanded view"
                    sx={{ 
                        color: "white", 
                        borderColor: "white",
                        '&:hover': {
                            borderColor: "white",
                            backgroundColor: "rgba(255, 255, 255, 0.1)",
                        }
                    }}
                >
                    Close
                </Button>
            </DialogTitle>
            <DialogContent sx={{ p: 4, mt: 2 }}>
                {CardComponent && (
                    <DashboardCardContext.Provider value={{ isExpanded: true }}>
                        <CardComponent key={cardId} />
                    </DashboardCardContext.Provider>
                )}
            </DialogContent>
        </Dialog>
    );
};